var _defs, _path, _line, _polyline, _line2, _path2, _polyline2, _line3, _polyline3, _line4, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_10",
    "data-name": "Capa 10",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 395.38 385.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #9362c7;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 15px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.48,303.56l-71.96,68.79c-6.81,6.51-17.54,6.49-24.33-.04L13.46,261.98c-7.82-7.52-7.97-19.98-.34-27.68L188.08,57.69c4.7-4.74,11.09-7.41,17.77-7.41h105.16c11.01,0,20.07,8.68,20.53,19.69l4.71,112.22c.26,6.24-2.14,12.31-6.6,16.68l-67.78,66.44"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 239.78,
    y1: 288.26,
    x2: 249.13,
    y2: 278.91
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "102.09 239.81 83.86 259.26 106.34 282.31 128.65 303.08"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.66,
    y1: 264.68,
    x2: 106.25,
    y2: 280.31
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.89,261.06l-45.28-44.91,11.28-11.36c4.79-4.83,11.97-6.7,18.36-4.38,3.85,1.39,7.52,4.16,9.36,9.47,2.36,6.77,.36,14.31-4.71,19.38l-4.77,4.77,39.3,2.59"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "193.61 149.02 174.34 167.06 220.02 211.49 238.48 193.53"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 214.41,
    y1: 173.03,
    x2: 197.69,
    y2: 189.76
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "237.26 106.08 217.99 124.12 263.67 168.55 282.13 150.59"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 258.06,
    y1: 130.09,
    x2: 241.34,
    y2: 146.82
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 333.16,
    cy: 53.53,
    r: 38.35
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/free.67d3497fa1bf06cd04c0b7a5627f948f.svg";
export { ForwardRef as ReactComponent };